import React from "react";
import { Link } from "react-router-dom";
import news_icon from "../../images/Icons/news.png";
import { useEffect } from "react";
import placeImage from "../../images/placeholder.jpg";
import { useDispatch, useSelector } from "react-redux";
import { fetchNews } from "../../redux/slice/news";

export default function News() {
  const dispatch = useDispatch();
  const { newsData, isError } = useSelector((state) => state.news);
  useEffect(() => {
    if (!isError) {
      dispatch(fetchNews());
    }
  }, [dispatch, isError]);
  const imageOnError = (event) => {
    event.currentTarget.src = placeImage;
  };

  return (
    <>
      <div className="container-fluid">
        <div className="showcase-product mrty1">
          <div className="row-hd-txt">
            <div className="row-hd-txt-left">
              <img src={news_icon} alt="icon" />
              <h5>Market News</h5>
            </div>
            <Link to="/news-list" className="row-hd-txt-right">
              View All<i className="bi bi-arrow-right-circle-fill ms-1"></i>
            </Link>
          </div>
          <div className="row shwc-pd-row">
            {newsData.map((data, index) => {
              return (
                <div className="col-lg-3 col-md-4 col-6 px-2" key={index}>
                  <Link to={`/news-detail/${data.slug}`} className="shwc-pd-dt">
                    <figure>
                      <img
                        src={data.image}
                        onError={imageOnError}
                        alt="product"
                      />
                    </figure>

                    <span className="two-line-clamp">{data.title}</span>
                    <button className="news-link">Continue Reading</button>
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
